import domReady from '@wordpress/dom-ready';

domReady(() => {
  const wrapper = document.querySelector('.sticky-product-wrapper');
  const sentinel = document.querySelector('.banner-header');

  if (!wrapper || !sentinel) {
    return;
  }

  const observer = new IntersectionObserver(
    ([entry]) => {
      wrapper.classList.toggle('is-sticky', !entry.isIntersecting);
    },
    { threshold: 0 }
  );

  observer.observe(sentinel);

  const productForm = document.querySelector('#product-form');
  if (productForm) {
    wrapper.querySelectorAll('.buy-btn a').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        productForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }
});
